import { render, staticRenderFns } from "./EcommerceTemporary.vue?vue&type=template&id=54184a97&scoped=true&"
import script from "./EcommerceTemporary.vue?vue&type=script&lang=js&"
export * from "./EcommerceTemporary.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceTemporary.vue?vue&type=style&index=0&id=54184a97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54184a97",
  null
  
)

export default component.exports